import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Typography from "../Typography/Typography";
import HeadingCTA from "../HeadingCTA/HeadingCTA";
import Container from "@material-ui/core/Container";
import { Grid, Box } from "@material-ui/core";
import TextInput from "../Form/TextInput/TextInput";
import { Formik, Form } from "formik";
import Button from "../../components/Button/Button";
import axios from "axios";
import { mobileViewBreakpoint } from "../helper";

const useStyles = makeStyles(theme => ({
  contactUsWrapper: {
    overflow: "hidden"
  },
  containerWrapper: {
    maxWidth: 1234,
    paddingLeft: 32,
    paddingRight: 32,
    [theme.breakpoints.down(mobileViewBreakpoint)]: {
      paddingLeft: 16,
      paddingRight: 16
    }
  },
  headingCTAWrapper: {
    marginTop: "160px",

    [theme.breakpoints.down(mobileViewBreakpoint)]: {
      marginTop: "64px",
      marginBottom: "22px"
    }
  },
  inputWrapper: {
    marginBottom: "8px",
    width: 'calc("100%-400px")'
  },
  buttonWrapper: {
    justifyContent: "flex-start",
    display: "flex",
    marginBottom: "120px",
    marginTop: "30px"
  },
  bodySmallWrapper: {
    flexDirection: "row",
    justifyContent: "space-between",
    "& p": {
      color: "rgba(0, 0, 0, 0.5)"
    },
    "& a": {
      color: "#CC4A01!important",
      fontWeight: "bold",
      "&:hover": {
        color: "#CC4A01!important",
        fontWeight: "bold"
      }
    }
  },
  headerWrapper: {
    marginBottom: "80px",
    [theme.breakpoints.down(mobileViewBreakpoint)]: {
      marginBottom: "48px"
    }
  }
}));

const ContactUs = () => {
  const classes = useStyles();
  const theme = useTheme();

  const isMobileView = useMediaQuery(
    theme.breakpoints.down(mobileViewBreakpoint)
  );

  const [serverState, setServerState] = useState({
    submitting: false,
    status: null
  });

  const [formSent, setsetFormSent] = useState(false);

  const handleServerResponse = (ok, msg, resetForm) => {
    setServerState({
      submitting: false,
      status: { ok, msg }
    });
    if (ok) {
      resetForm();
      setsetFormSent(true);
      // reset form
      //form.reset();
    }
  };

  const handleSubmit = (query, resetForm) => {
    const formData = new FormData();
    Object.entries(query).forEach(([key, value]) => {
      formData.append(key, value);
    });

    axios
      .post(
        "https://getform.io/f/c7ad1429-6959-4612-b371-23fd3081ed99",
        formData,
        { headers: { Accept: "application/json" } }
      )
      .then(function(response) {
        handleServerResponse(true, "Thanks!", resetForm);
      })
      .catch(function(error) {
        handleServerResponse(false, response.data.error, resetForm);
      });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={{
        reason: "",
        organisation: "",
        fullName: "",
        email: "",
        message: ""
      }}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={async (values, { resetForm }) => {
        handleSubmit(values, resetForm);
      }}
    >
      {props => {
        const { values, errors, handleChange, submitForm } = props;
        return (
          <Form>
            <div className={classes.headingCTAWrapper}>
              <Container className={classes.containerWrapper} maxWidth={false}>
                <div className={classes.headerWrapper}>
                  <HeadingCTA
                    subheading={"Contact Us"}
                    title={
                      <>
                        Get in touch with us. <br />
                        We are waiting to hear from you.
                      </>
                    }
                    center
                  />
                </div>
                <div className={classes.divWrapper}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                    bgcolor="background.paper"
                  >
                    <Grid container spacing={2}>
                      {serverState.status && serverState.status.ok !== null && (
                        <Typography
                          customVariant="h5Regular"
                          style={{ margin: 80 }}
                        >
                          Thank you for contacting us.
                        </Typography>
                      )}

                      {!formSent && (
                        <>
                          <Grid
                            className={classes.inputWrapper}
                            item
                            xs={isMobileView ? 12 : 6}
                          >
                            <TextInput
                              name="reason"
                              label="Reason for contact"
                              placeholder="I’m looking for a quote"
                              value={values.reason}
                              onChange={handleChange}

                              // error={touched.email && errors.email}
                            />
                          </Grid>
                          <Grid
                            className={classes.inputWrapper}
                            item
                            xs={isMobileView ? 12 : 6}
                          >
                            <TextInput
                              name="organisation"
                              label="Organisation"
                              placeholder="What company do you work for?"
                              value={values.organisation}
                              onChange={handleChange}

                              // error={touched.email && errors.email}
                            />
                          </Grid>

                          <Grid
                            className={classes.inputWrapper}
                            item
                            xs={isMobileView ? 12 : 6}
                          >
                            <TextInput
                              name="fullName"
                              label="Full Name"
                              placeholder="Enter your name"
                              value={values.fullName}
                              onChange={handleChange}

                              // error={touched.email && errors.email}
                            />
                          </Grid>
                          <Grid
                            className={classes.inputWrapper}
                            item
                            xs={isMobileView ? 12 : 6}
                          >
                            <TextInput
                              name="email"
                              label="Email Address"
                              placeholder="What’s your email address?"
                              value={values.email}
                              onChange={handleChange}

                              // error={touched.email && errors.email}
                            />
                          </Grid>
                          <Grid className={classes.inputWrapper} item xs={12}>
                            <TextInput
                              rows={3}
                              multiline
                              name="message"
                              label="Message"
                              placeholder="Can you be specific about you need?"
                              value={values.message}
                              onChange={handleChange}
                              // error={touched.email && errors.email}
                            />
                          </Grid>
                        </>
                      )}
                    </Grid>
                  </Box>

                  {!formSent && (
                    <div className={classes.bodySmallWrapper}>
                      <Typography customVariant="bodySmall">
                        Please read our <a href="#">Privacy Policy</a> to see
                        how we use your personal information.
                      </Typography>

                      <div
                        className={classes.buttonWrapper}
                        onClick={submitForm}
                      >
                        <Button submit>Submit</Button>
                      </div>
                    </div>
                  )}
                </div>
              </Container>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default ContactUs;
